'use client';

import { useEffect } from "react";
import { mixpanelTrackPageView } from "@/utils/mixpanel";
import { SupportedLanguage } from "@/config/store/globalStore";
import { useSetAtom } from "jotai";
import { currentLanguage } from "@/config/store/globalStore";
import CenterLayout from "@/layout/CenterLayout";
import HeroSection from "./_components/HeroSection";
import FeaturedRestaurants from "./_components/FeaturedRestaurants";
import FeaturedAttractions from "./_components/FeaturedAttractions";
import RecentBlogs from "./_components/RecentBlogs";
import CallToAction from "./_components/CallToAction";
import FeatureIntro from "./_components/FeatureIntro";

interface HomePageProps {
  lang: SupportedLanguage;
}

export default function HomePage({ lang }: HomePageProps) {
  const setLanguage = useSetAtom(currentLanguage);

  useEffect(() => {
    setLanguage(lang);
    mixpanelTrackPageView('HomePage');
  }, [lang, setLanguage])

  return (
    <CenterLayout>
      <div className="py-8 md:py-16">
      <HeroSection />
      <FeatureIntro />

        {/* 기존 컨텐츠 */}
        <div className="mt-32">
          <FeaturedRestaurants />
          <FeaturedAttractions />
          <RecentBlogs />
          <CallToAction />
        </div>
      </div>
    </CenterLayout>
  )
}